// extracted by mini-css-extract-plugin
export var root = "Affix-module--root--378f8";